<template>
  <div id="consulting-case">
    <v-container grid-list-xl>
      <v-layout align-center row wrap>
        <v-flex sm4 xs12>
          <div class="headline">Consulting Case</div>
        </v-flex>
        <v-flex sm3 xs6>
          <v-autocomplete
            :items="users"
            clearable
            item-text="phone"
            item-value="phone"
            label="User"
            v-model="searchPhone"
          ></v-autocomplete>
        </v-flex>
        <v-flex sm3 xs6>
          <v-autocomplete
            :items="consultingTopics"
            clearable
            item-text="name"
            item-value="name"
            label="Topic"
            v-model="searchTopic"
          ></v-autocomplete>
        </v-flex>

        <v-flex sm2 text-xs-center xs12>
          <ConsultingCaseDialog />
        </v-flex>
        <v-flex xs12>
          <!-- Data Table -->
          <v-data-table
            :headers="headers"
            :items="filterStates"
            :loading="tableLoading"
            class="elevation-0"
            disable-initial-sort
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr @click="editItem(props.item.idx)">
                <td>{{ props.item.idx }}</td>
                <td>{{ props.item.consultingBeneficiaryName || '-' }}</td>
                <td>{{ props.item.fullname || '-' }}</td>
                <td>{{ props.item.phone || '-' }}</td>
                <td>{{ props.item.problems || '-' }}</td>
                <td>{{ props.item.acceptDate ? props.item.acceptDate.slice(0, 10) : '-' }}</td>
                <td>{{ props.item.acceptTime ? props.item.acceptTime.slice(0, 5) : '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import store from '@/store'

import ConsultingCaseDialog from '@/components/admin/ConsultingCaseDialog'
export default {
  name: 'consulting-topic',
  components: {
    ConsultingCaseDialog
  },
  data() {
    return {
      users: [],
      searchPhone: '',
      searchTopic: '',
      // Table
      tableLoading: false,
      headers: [
        { text: 'ID', align: 'left', value: 'idx', width: '10' },
        { text: 'Beneficiary', align: 'left', value: 'consultingBeneficiaryName', width: '200' },
        { text: 'User', align: 'left', value: 'fullname', width: '400' },
        { text: 'Phone', align: 'left', value: 'phone', width: '200' },
        { text: 'Problems', align: 'left', value: 'problems', width: '400' },
        { text: 'Date', align: 'left', value: 'acceptDate', width: '200' },
        { text: 'Time', align: 'left', value: 'acceptTime', width: '100' }
      ]
    }
  },
  beforeRouteEnter: (to, from, next) => {
    store.state.ConsultingCase.data.length === 0 // main fetch
      ? store.dispatch('ConsultingCase/fetch').then(next())
      : next()

    if (store.state.ConsultingTopic.data.length === 0) store.dispatch('ConsultingTopic/fetch')
    if (store.state.ConsultingBeneficiary.data.length === 0)
      store.dispatch('ConsultingBeneficiary/fetch')
  },
  computed: {
    filterStates() {
      if (this.searchPhone) {
        return this.states.filter(item => item.phone == this.searchPhone)
      }
      if (this.searchTopic) {
        return this.states.filter(item => item.consultingTopicName == this.searchTopic)
      } else {
        return this.states
      }
    },
    states() {
      return this.$store.getters['ConsultingCase/getAll']
    },
    consultingTopics() {
      return this.$store.getters['ConsultingTopic/getAll']
    }
  },
  async created() {
    this.getUsers()
  },
  methods: {
    async getUsers() {
      try {
        const response = await this.axios.get(`farmerspace/users`)
        this.users = response.data
      } catch (error) {
        throw new Error(error)
      }
    },
    editItem(idx) {
      this.$store.commit('ConsultingCase/UPDATE_DIALOG', true)
      this.$store.commit('ConsultingCase/SET_IDX', idx)
    }
  }
}
</script>

<style lang="scss" scoped></style>
